//  to remove later
import { HTTP_VERBS } from "../../enums";
import { SubmitAcpFormDtoV2 } from "../domainObjects/acpSubmitV2";

export const httpVerb = HTTP_VERBS.POST;
export const url = "/api/v3/acp/create";

export class Body extends SubmitAcpFormDtoV2 {}

export class Response {}
